import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { Services } from '@/services/services'
import { CurrentSession } from '@/services/repository/session'
import { addServerErrors, FieldProps, FormDataBase, FormWrapper } from '@/components/forms/common/FormBase'
import { datePickerField, numericField, textField } from '@/components/forms/common/fields'
import { Spinner } from '@/components/spinner'

export interface MachineServiceFieldsFormData extends FormDataBase {
    udtNumber?: string
    udtReviewDate?: string
    udtExpirationDate?: string
    inspectionDate?: string
    inspectionExpirationDate?: string
    mthExpiration?: number
}

export const ServicemanEditMachineServiceFieldsPopup = ({ services, session, onClose, machineId, title, onSaved }: {
    services: Services
    session: CurrentSession
    onClose: () => void
    machineId: string
    title?: string
    onSaved?: () => void
}) => {
    const form = useForm<MachineServiceFieldsFormData>()
    const [loaded, setLoaded] = useState(false)

    useEffect(() => {
        setLoaded(false)
        services.session.fetchWithToken(`/api/serviceman/machines/byid/${machineId}`).then((r) => r.json()).then((data) => {
            form.reset({
                udtNumber: data?.udtNumber || '',
                udtReviewDate: data?.udtReviewDate,
                udtExpirationDate: data?.udtExpirationDate,
                inspectionDate: data?.inspectionDate,
                inspectionExpirationDate: data?.inspectionExpirationDate,
                mthExpiration: data?.mthExpiration,
            })
            setLoaded(true)
        })
    }, [machineId])

    const handle = (data: MachineServiceFieldsFormData): Promise<void> => {
        return services.session.fetchWithToken(`/api/serviceman/machines/byid/${machineId}/service-fields`, {
            method: 'PUT',
            body: JSON.stringify(data),
        }).then(async (r) => {
            if (r.status !== 200) {
                const errors = await r.json()
                addServerErrors(form, session.translates, errors)
                return
            }
            onSaved?.()
            onClose()
        })
    }

    const fieldProps: FieldProps<MachineServiceFieldsFormData> = {
        services,
        form,
        translates: session.translates,
        formName: 'machine',
        readOnly: false,
        fieldName: 'udtReviewDate',
        required: false,
    }

    return <div className='service-fields-popup'>
        <h3>{title ? title + ' - ' : null}{session.translates.for('elements.table.machines.menu.edit.edit_service_fields')}</h3>
        {loaded ? <FormWrapper<MachineServiceFieldsFormData> className='main-form' form={form} formName='machine' translates={session.translates} onSubmit={handle}>
            {textField<MachineServiceFieldsFormData>()({ ...fieldProps, fieldName: 'udtNumber' })}
            {datePickerField<MachineServiceFieldsFormData>()({ ...fieldProps, fieldName: 'udtReviewDate' })}
            {datePickerField<MachineServiceFieldsFormData>()({ ...fieldProps, fieldName: 'udtExpirationDate' })}
            {datePickerField<MachineServiceFieldsFormData>()({ ...fieldProps, fieldName: 'inspectionDate' })}
            {datePickerField<MachineServiceFieldsFormData>()({ ...fieldProps, fieldName: 'inspectionExpirationDate' })}
            {numericField<MachineServiceFieldsFormData>()({ ...fieldProps, fieldName: 'mthExpiration' })}
        </FormWrapper> : <Spinner />}
    </div>
}
